import React from "react";
import style from "../../components/ModalPopup/ModalPopup.module.scss";
import { Modal } from "react-bootstrap";

import closeIcon from "../../components/Icons/closeIconGreen.svg";


export interface PopUpProps {
  show: boolean;
  onHide: any;
  bodyHead?: string;
  bodyTitle?: string;
}

const ModalPopup = (props: PopUpProps) => {
  const {
    show,
    onHide,
    bodyHead,
    bodyTitle,
  } = props;
  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      className={style.GuideEnvironmentCloseIconModal}
    >
      <div className={style.modalBodayMain}>
        <Modal.Body>
          <div className={style.GuideEnvironmentCloseIcon}>
            <img
              onClick={onHide}
              src={closeIcon}
              alt="closeIcon"
              width={19.94}
              height={19.9}
            />
          </div>
          <div className={style.modalBoday}>
            <span className={style.modalBodayHeader}>{bodyHead}</span>
            <span className={style.modalBodayTitle}>{bodyTitle}</span>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
};
export default ModalPopup;
